/** Public bucket for images and videos shown on form pages (builder uploads and seeded questionnaire pictures). */
export const FORM_MEDIA_BUCKET = "form-media";
